import * as moment from "moment";

import { actionTypes as customerTeamsActions } from "../customerTeam";
import { customerTeams } from "../customerTeam/reducer";

import * as actions from "./actiontypes";
import { CustomerAction } from "./actions";
import { CustomerDetailModel, CustomerDetailModelInRedux, CustomerInRedux, PartialCustomerModelInRedux  } from "./model";

export function customers(state: CustomerInRedux[] = [], action: CustomerAction): CustomerInRedux[] {
    switch (action.type) {
        case actions.LOAD_CUSTOMERS_SUCCESS:
            return action.payload.map(c => ({ ...c, listUpdated: moment() }));
        case actions.SAVE_CUSTOMER_SUCCESS:
        case actions.LOAD_CUSTOMER_DETAIL_SUCCESS:
            if (state.some(c => c.id === action.payload.id)) {
                return state.map(c => customer(c, action));
            }
            return [...state, detailUpdated(action.payload)];
        case actions.CREATE_CUSTOMER_SUCCESS:
            return [...state, detailUpdated(action.payload)];
        case actions.DELETE_CUSTOMER_SUCCESS:
            return [...state.filter(c => c.id !== action.payload)];
        case actions.ACTIVATE_CUSTOMER_SUCCESS:
            const activatedCustomer = state.find(c => c.id === action.payload)!;
            return [...state.filter(c => c.id !== action.payload), { ...activatedCustomer, active: true }];
        case actions.DEACTIVATE_CUSTOMER_SUCCESS:
            const deactivatedCustomer = state.find(c => c.id === action.payload)!;
            return [...state.filter(c => c.id !== action.payload), { ...deactivatedCustomer, active: false }];
        case customerTeamsActions.LOAD_CUSTOMER_TEAMS_SUCCESS:
        case customerTeamsActions.UPDATE_CUSTOMER_TEAM_SUCCESS:
        case customerTeamsActions.CREATE_CUSTOMER_TEAM_SUCCESS:
            return state.map(c => customer(c, action));
        default:
            return state;
    }
}

function customer(state: PartialCustomerModelInRedux, action: CustomerAction): CustomerInRedux {
    switch (action.type) {
        case actions.SAVE_CUSTOMER_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        case actions.LOAD_CUSTOMER_DETAIL_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        case customerTeamsActions.LOAD_CUSTOMER_TEAMS_SUCCESS:
        case customerTeamsActions.UPDATE_CUSTOMER_TEAM_SUCCESS:
        case customerTeamsActions.CREATE_CUSTOMER_TEAM_SUCCESS:
            if (action.payload.customerId === state.id) {
                return { ...state, teams: customerTeams(state.teams, action) };
            }
            return state;
        default:
            return state;
    }
}

function detailUpdated(value: CustomerDetailModel, state: Partial<CustomerInRedux> = {}): CustomerDetailModelInRedux {
    return { listUpdated: moment(), ...state, ...value, detailUpdated: moment() };
}
